import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EAP_APP, GM_APP, IST_APP } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { httpOptions, serviceConstants } from 'src/app/constants/service.constants';
@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss']
})
export class ReferencesComponent {
  selectedUsers: any[]=[];
  selectedDocs: any[]=[];
  selectedRevDocs: any[]=[];
  @Input() public Content: any;
  content: any; 
  appCode: any; 
  ReviewId: any;  
  ReviewerStatus:boolean = false;
  PopupType: any; 
  IsInProgess:boolean = false;
  ReviewStatus:any;
  IsDocReviewComp: boolean = false;
  
  constructor(private modalService: NgbModal, 
    private reviewService: ReviewService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    public modalRef: NgbActiveModal, 
    private ngbModal: NgbModal,   
    ){}
  
  ngOnInit(){
    if (this.Content.content !== null) { 
      this.appCode = this.Content.content.applicationCode; 
      this.ReviewStatus = this.Content.content.ReviewStatus;  
      this.PopupType= this.Content.content.PopupType;  
      if(this.Content.content.ReviewId!=null && this.Content.content.ReviewId!="" && this.Content.content.ReviewId!=undefined)
       {
           this.ReviewId = this.Content.content.ReviewId;
           this.GetReviewDetails();
       }
      }
  }

  GetReviewDetails() {
    this.reviewService.ReviewDetailsForReferences("api/Review/ReviewDetailsForReferences?Id=" + this.ReviewId).subscribe((result: any[] )=> {
      if (result) {
       this.selectedUsers=[];
       this.selectedUsers=result["Reviewers"];
       
       this.selectedUsers.forEach((item) => {
        // item.PARENT_FIELD_CODE=="InProgress"
        if(item.UserStatus ==0 || item.UserStatus==1)
        {
          this.IsInProgess=true;
        }
      });
       this.selectedDocs=[];
       this.selectedDocs=result["lstReviewDocuments"];
      
       //Hiding of Preview and Download icons
        this.selectedDocs.forEach((item) => {         
          item.lstReviewerDocuments.forEach(element => {
            if (element.DocStatus > 1) {
              this.IsDocReviewComp = true;
            } else {
              this.IsDocReviewComp = false;
            }
          });
        });

       this.selectedRevDocs=[];
       this.selectedRevDocs=result["lstRevDocuments"];      
        //Hiding of Preview and Download icons
        this.selectedRevDocs.forEach((item) => {   
            if (item.DocStatus > 1) {
              this.IsDocReviewComp = true;
            } else {
              this.IsDocReviewComp = false;
            }
          
        }); 
      }
    });
  }
 
  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/Review/DownloadFileByDocId?ReviewDocId=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "review");
  }
  UpdateReviewer(id:any)
  {       
      this.reviewService.CheckReviwerToAbort("api/Review/CheckReviwerToAbort?ReviewerId=" + id).subscribe(result => {
      if (result.Status == 0) {       
        this.selectedUsers.forEach((item)=>{
          if(item.ReviewerId==id)
          {
            item.Status="Aborted";
            item.UserStatus = 3;
            item.IsEdit=true;
            item.IsIconEdit=false;
          }
        }); 
      }
      else{
        this.commonService.ValidationBanner(result.Message);
      }    
    }); 
  }

  UpdateReviewerStatus(){
    let formData = { "ID":this.ReviewId , "Application_Code":this.appCode,
    "Reviewers":this.selectedUsers
      };     
      this.reviewService.UpdateReviewerStatus("api/Review/UpdateReviewerStatus", formData).subscribe(result => {
      if (result.Status == 0) {       
          this.commonService.SuccessBanner(result.Message);
          this.modalRef.close();
      }
      else{
        this.commonService.ValidationBanner(result.Message);
      }    
    });
  }
  
  close() {   
    this.modalService.dismissAll();   
  }
}
